import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Description } from "@/components/Description";
import { SkipButton } from "@/components/dialog/create-team/SkipButton";
import { UploadTeamAvatarForm } from "@/components/dialog/team/update-team-form/UploadTeamAvatarForm";
import { FormButton } from "@/components/form/FormButton";
import { Title } from "@/components/Title";
import { useStore } from "@/store";

export const StepAvatar = observer(function StepAvatar() {
  const { dialog } = useStore();
  const { createTeamDialog } = dialog;
  const t = useTranslations();

  if (!createTeamDialog.team) {
    return null;
  }

  const handleButtonClick = () => {
    createTeamDialog.setStep("invites");
  };

  return (
    <>
      <Title
        value={t("createTeamDialog.stepAvatar.title", { team: createTeamDialog.team.title })}
      />
      <Description value={t("createTeamDialog.stepAvatar.description")} />
      <UploadTeamAvatarForm team={createTeamDialog.team} size="large" />
      {createTeamDialog.team.avatarUrls?.[120] ? (
        <FormButton
          variant="accent"
          size="sm"
          type="submit"
          className="w-full"
          onClick={handleButtonClick}
        >
          {t("createTeamDialog.continueButton")}
        </FormButton>
      ) : (
        <SkipButton onClick={handleButtonClick} />
      )}
    </>
  );
});
